import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button, Centered, Column, Footer, Headings, Logo, Padding, ExternalLink } from '..'
import colors from '../../constants/colors'

const { H1, H2 } = Headings

const GrayText = styled.span`
    color: ${colors.greydark};
`

const RedText = styled.span`
    color: ${colors.red};
`

const getCurrentYear = () => new Date().getFullYear()
/**
 * ErrorPage Container
 */
function ErrorPageDom(props) {
    const { error, errorContent, errorHeader, errorInfo, goBack, infoStack, onClickLogout, selectedEstate, t } = props
    return (
        <>
            <Column withBackground color={colors.blue}>
                <Centered horizontal vertical>
                    <Logo />
                </Centered>
            </Column>
            <Column>
                <Centered vertical>
                    <Padding size="md">
                        <H1>
                            {errorHeader}
                            <br />
                        </H1>
                        <Padding size="sm" top>
                            <H2>
                                <GrayText>
                                    {errorContent}
                                    &nbsp;
                                    {error && errorInfo && (
                                        <ExternalLink
                                            href={`mailto:admin@volumenetwork.com?subject=Hubble ${selectedEstate} Issue Report&body=Estate:%0D${selectedEstate}%0D%0DSO:%0D${navigator.userAgent}%0D%0DError:%0D${error}%0D%0DError trace:%0D${errorInfo}%0D%0DStack trace:%0D${infoStack}%0D%0D`}
                                        >
                                            Report Problem
                                        </ExternalLink>
                                    )}
                                </GrayText>
                                {error && errorInfo && (
                                    <RedText>
                                        <br />
                                        <br />
                                        {error}
                                        <br />
                                        <br />
                                        {errorInfo.slice(0, 250)}
                                        &hellip;
                                    </RedText>
                                )}
                            </H2>
                            <Padding size="lg" top>
                                {onClickLogout && (
                                    <Button theme="main" fullWidth onClick={onClickLogout}>
                                        {t('BackLogin')}
                                    </Button>
                                )}
                                {typeof goBack === 'function' && (
                                    <Button theme="main" fullWidth onClick={goBack}>
                                        {t('back')}
                                    </Button>
                                )}
                            </Padding>
                        </Padding>
                    </Padding>
                </Centered>
                <Footer background={colors.bluelightest}>
                    <GrayText>{`© ${getCurrentYear()} Volume. All Rights Reserved.`}</GrayText>
                </Footer>
            </Column>
        </>
    )
}

ErrorPageDom.propTypes = {
    error: PropTypes.string,
    errorContent: PropTypes.string.isRequired,
    errorHeader: PropTypes.string.isRequired,
    errorInfo: PropTypes.string,
    goBack: PropTypes.func,
    infoStack: PropTypes.string,
    onClickLogout: PropTypes.func,
    selectedEstate: PropTypes.string,
    t: PropTypes.func.isRequired,
}

ErrorPageDom.defaultProps = {
    error: null,
    errorInfo: null,
    goBack: null,
    infoStack: null,
    onClickLogout: null,
    selectedEstate: null,
}

const mapStateToProps = ({ app: { selectedEstate } }) => ({
    selectedEstate,
})

export default connect(mapStateToProps)(withTranslation()(ErrorPageDom))
